import { ConsulDataResponse } from './getConsulData'

export const decodeConsulData = (data: ConsulDataResponse) => {
  const decodedData = Buffer.from(data[0].Value, 'base64').toString('utf-8')
  const jsonData = JSON.parse(decodedData)

  return jsonData
}
